import { call, put, select } from "redux-saga/effects";

import { ScreenerStore, ScreenerStoreFilter } from "../model";
import { filterSet} from "../actions";
import { allFieldConfiguration } from "../../fields";
import { paramsToQueryStringSerialize } from "./paramsToQueryStringSerialize";

export function* calculateFilterSettings(saveValues: boolean) {
	const store: ScreenerStore = yield select();

	const currency = store.preference.currency;
	const etfs = store.data.etfs;

	const newFilter: ScreenerStoreFilter = { inputs: { } };
	for (const fieldConfiguration of allFieldConfiguration) {
		newFilter.inputs[fieldConfiguration.systemName] = fieldConfiguration.createDefaultInput(etfs, currency);
	}

	yield put(filterSet(newFilter));
	if (saveValues)
		yield call(paramsToQueryStringSerialize);
}
